import { useMemo } from 'react';

import { Card, Divider, Group, Skeleton, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { IconChevronRight } from 'ui-icons';

import { cx } from '../../../../Provider/Provider';
import { centsToDollar } from '../../../../Utils/currencyUtils';
import classes from './BalanceCard.module.css';

type Props = {
  title?: string;
  withBackgroundImage?: boolean;
  available?: number;
  pending?: number;
  isLoading: boolean;
  onClick?: () => void;
};
const BalanceCard = ({
  title,
  withBackgroundImage = false,
  available,
  pending,
  isLoading,
  onClick,
}: Props) => {
  const availableBalance = useMemo(() => {
    return centsToDollar(available);
  }, [available]);
  const pendingBalance = useMemo(() => {
    return centsToDollar(pending);
  }, [pending]);

  return (
    <Card
      className={cx(classes.card, {
        [classes['card--with_background_image']]: withBackgroundImage,
      })}
      onClick={() => onClick?.()}
      mod={{ clickable: onClick ? true : false }}
    >
      <Stack justify="space-between" gap="lg" h="100%">
        {title && (
          <Group justify="space-between" className={classes.header}>
            <Title order={4}>{title}</Title>
            {onClick && (
              <ThemeIcon variant="transparent" c="white" size={18} onClick={onClick}>
                <IconChevronRight />
              </ThemeIcon>
            )}
          </Group>
        )}
        <Group className={classes.balanceContainer}>
          <Stack gap={1} h={72} py={4} flex={1}>
            <Text fz={14} c="gray.2">
              Available
            </Text>
            <Skeleton visible={isLoading}>
              <Text fz={28} fw={500}>
                {availableBalance}
              </Text>
            </Skeleton>
          </Stack>
          <Divider orientation="vertical" opacity={0.5} />
          <Stack gap={1} h={72} py={4} flex={1}>
            <Text fz={14} c="gray.2">
              Pending
            </Text>
            <Skeleton visible={isLoading}>
              <Text fz={28} fw={500}>
                {pendingBalance}
              </Text>
            </Skeleton>
          </Stack>
        </Group>
      </Stack>
    </Card>
  );
};

export { BalanceCard };
